import { ChatCompletionRequestMessage } from "openai";
import { Dispatch, SetStateAction } from "react";
import { ReactFlowInstance, XYPosition } from "reactflow";
import { TypeChatNode } from "../../nodes/response-node/response-node.model";
import { TypeMemoNode } from "../../nodes/memo-node/memo-node.model";
import { createTopicNode } from "../../nodes/topic-node/topic-node.helper";
import { TopicNodeData } from "../../nodes/topic-node/topic-node.model";
import { uuid } from "../../utils";
import { InstanceState } from "../semantic-dive/semantic-dive";

// When a highlight is dragged out of text
export const onDragStart = (
  sourceNodeId: string,
  event: any,
  nodeType: string,
  context: ChatCompletionRequestMessage[],
  topicName: string,
  reactFlowInstance: ReactFlowInstance
) => {
  event.dataTransfer.setData('dragNodeType', nodeType);
  event.dataTransfer.effectAllowed = 'move';
  const currNode: TypeMemoNode | TypeChatNode | undefined = reactFlowInstance.getNode(sourceNodeId);
  if (currNode) {
    const data = JSON.stringify({
      parentId: sourceNodeId,
      chatHistory: [
        ...context,
        {
          role: 'user',
          content: topicName
        }
      ],
      instanceState: InstanceState.NONE,
      state: {
        topic: topicName
      }
    } as TopicNodeData);
    console.log(data);
    event.dataTransfer.setData('dragNodeData', data);
  }
};

export const highlightSelection = (
  sourceNodeId: string,
  context: ChatCompletionRequestMessage[],
  [highlightIds, setHighlightIds]: [string[], Dispatch<SetStateAction<string[]>>],
  reactFlowInstance: ReactFlowInstance
) => {
  const selection = document.getSelection();
  if ((selection?.rangeCount ?? 0) <= 0) {
    return;
  }
  const range: Range = selection?.getRangeAt(0) ?? new Range;
  const selectedText = range.toString();
  if (isHighlightable(range)) {
    const highlight = document.createElement('highlight-text', {is: selectedText});
    highlight.draggable = true;
    highlight.innerHTML = selectedText;
    range.surroundContents(highlight);
    highlight.classList.add('highlight-elm');
    highlight.id = `highlight-${highlightIds.length}`;
    setHighlightIds(highlightIds.concat([highlight.id]));

    highlight.addEventListener('click', (event) => {
      range.extractContents();
      range.insertNode(document.createTextNode(selectedText));
      range.commonAncestorContainer.normalize();
    })
    highlight.addEventListener('dragstart', (event) => {
      onDragStart(
        sourceNodeId,
        event,
        'topic',
        context,
        selectedText,
        reactFlowInstance
      );
    })
    window.getSelection()?.removeAllRanges();
  }
}

// Functions for highlighting in the baseline chat panel

// When a highlight is dragged out of text
export const onDragStartFromChat = (event: any, nodeType: string, text: string) => {
  event.dataTransfer.setData('dragNodeType', nodeType);
  event.dataTransfer.effectAllowed = 'move';
  const data = JSON.stringify({ label: text });
  event.dataTransfer.setData('dragNodeData', data);
};

export const highlightChatSelection = (reactFlowInstance: ReactFlowInstance, flowWrapper: any) => {
  const selection = document.getSelection();
  if ((selection?.rangeCount ?? 0) <= 0) {
    return;
  }
  const range: Range = selection?.getRangeAt(0) ?? new Range;
  const selectedText = range.toString();
  console.log(range);
  if (isHighlightable(range) && range.commonAncestorContainer.parentElement?.localName === 'p') {
    const highlight = document.createElement('highlight-text', {is: selectedText});
    highlight.draggable = true;
    highlight.innerHTML = selectedText;
    range.surroundContents(highlight);
    highlight.classList.add('highlight-elm');
    highlight.id = `highlight-${uuid()}`;

    highlight.addEventListener('click', (event) => {

      if ((event.altKey || event.metaKey || event.shiftKey) && event.detail === 1) { // delete highlight when clicked with alt, command, or shift
        range.extractContents();
        range.insertNode(document.createTextNode(selectedText));
        range.commonAncestorContainer.normalize();
      } else if (event.detail === 1) {
        // generate topic node on the right side

        const highlightDiv = document.getElementById(highlight.id); 

        // const data = JSON.stringify({
        //   parentId: '',
        //   originalId: highlight.id,
        //   chatHistory: [],
        //   instanceState: InstanceState.NONE,
        //   state: {
        //     topic: selectedText,
        //     toolbarAvailable: false,
        //   }
        // } as TopicNodeData);

        const reactFlowBounds = flowWrapper?.current?.getBoundingClientRect();

        const viewport = reactFlowInstance.getViewport();

        let position: XYPosition;
        position = {
          x: - ((viewport.x) * (1/viewport.zoom)) + ( (reactFlowBounds.width * (1/viewport.zoom)) / 2),
          y: - ((viewport.y) * (1/viewport.zoom)) + ( (reactFlowBounds.height * (1/viewport.zoom)) / 2),
        };
        createTopicNode(selectedText, highlight.id, position, [], false, reactFlowInstance, false);
      } else if (event.detail === 2) { // delete highlight when you double click
        range.extractContents();
        range.insertNode(document.createTextNode(selectedText));
        range.commonAncestorContainer.normalize();
      }

    })
    highlight.addEventListener('dragstart', (event) => {
      onDragStartFromChat(event, 'default', selectedText);
    })
    window.getSelection()?.removeAllRanges();
  }
}

/**
 * Checks if highlight range is highlighting the same element, namely
 * innertext of parent element with nothing in between
 * @param highlightRange 
 * @returns 
*/
export const isHighlightable = (highlightRange: Range): boolean => {
  if (!highlightRange.toString()) {
    return false;
  }
  const parentNode = highlightRange.commonAncestorContainer;
  if (parentNode.nodeName !== '#text') {
    return false;
  }
  return true;
}
